<div class="container">
  <div class="row"><div class="col-12"><h3 style="color:#719eb6">BIP - Crisis Cycle</h3></div></div>
  <div *ngIf="loading()">
    <div class="row">
      <div class="col-12">
        <div class="d-flex justify-content-center">
          <div class="spinner-border text-primary" role="status" aria-label="Loading">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="!loading()">
    <div class="row mb-3" *ngIf="shouldShowToggle()">
      <div class="col-12 d-flex align-items-center gap-2">
        <p-selectButton
        [options]="[
          { label: 'Draft', value: false },
          { label: 'Current', value: true }
        ]"
        [ngModel]="isCurrentView" (onChange)="onIsCurrentViewChange($event)"
        autoWidth="false"
        [style]="{ width: '100%', display: 'flex' }"
        allowEmpty="false"
      >
      </p-selectButton>
        <span class="ms-2" style="color:#719eb6">{{ isCurrentView ? 'Viewing Current' : 'Editing Draft' }}</span>
      </div>
    </div>
  @if (isCurrentView) {
      <div class="row mb-3">
        <div class="col-12">
          @if (currentModel?.CrisisCycle) {
            <div class="text-wrap ck ck-content ck-editor__editable"
            style="background-color:#fff;border-radius:10px;padding:10px;margin:0;"
                [innerHTML]="currentModel?.CrisisCycle | safeHtml"></div>
          } @else {
            <div class="alert alert-info" role="alert">
              A current BIP has not yet been completed for this patient. Complete the draft and sign the BIP to finalize it.
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="row">
        <div class="col-12">
          <ckeditor
            id="bip-crisis-cycle"
            name="bip-crisis-cycle"
            [editor]="Editor"
            [config]="editorConfig"
            [data]="initialCrisisCycle"
            (change)="onCrisisCycleChange($event)"
          ></ckeditor>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 text-end">
          <button *ngIf="canEditBip" class="side-menu-button2" (click)="save()" [disabled]="!draftModel">Save Draft</button>
        </div>
      </div>
    }
  </ng-container>
</div>


